import { render } from "./SceneViewer.vue?vue&type=template&id=58eec982&ts=true"
import script from "./SceneViewer.vue?vue&type=script&lang=ts"
export * from "./SceneViewer.vue?vue&type=script&lang=ts"

import "./SceneViewer.vue?vue&type=style&index=0&id=58eec982&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__